import { alpha, Components, Theme } from '../../material';

const COMMON_COLOR_VARIANTS = [
  'aurora',
  'info',
  'success',
  'warning',
  'error',
] as const;

type Variant = NonNullable<
  NonNullable<Components<Theme>['MuiChip']>['variants']
>[number];

export const MuiChip: Components<Theme>['MuiChip'] = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      lineHeight: 1.3,
      color: theme.palette.text.primary,
      border: '1px solid',
      fontSize: 12,
    }),
    icon: {
      fontSize: 16,
      marginLeft: 8,
    },
    deleteIcon: ({ theme }) => ({
      fontSize: 16,
      color: theme.palette.action.active,
      '&:hover': {
        color: theme.palette.text.primary,
      },
    }),
    avatar: {
      width: 16,
      height: 16,
    },
  },
  variants: [
    ...COMMON_COLOR_VARIANTS.map(
      color =>
        ({
          props: { color },
          style: ({ theme }) => ({
            backgroundColor: alpha(theme.palette[color].main, 0.15),
            borderColor: alpha(theme.palette[color].main, 0.5),
          }),
        }) as const satisfies Variant
    ),
    {
      props: { color: 'default' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.other.filledInputBackground,
        borderColor: theme.palette.other.outlinedBorder,
      }),
    },
    {
      props: { color: 'transparent' },
      style: ({ theme }) => ({
        backgroundColor: 'transparent',
        color: 'inherit',
        borderColor: theme.palette.other.outlinedBorder,
      }),
    },
    {
      props: { disabled: true },
      style: ({ theme }) => ({
        color: theme.palette.text.disabled,
        backgroundColor: theme.palette.other.filledInputBackground,
        borderColor: theme.palette.action.disabled,
        opacity: '1 !important',
      }),
    },
  ],
};
